import cx from "classnames";
import { useState } from "react";

import { Logo } from "../Logo";
import {
  AccessMenu,
  CartButton,
  MenuButton,
  Navigation,
  SidebarMenu,
} from "./components";
import { HeaderStyleProps } from "./Header";
import header from "./header.module.css";

export const FullHeader = ({
  inverse,
  overlay,
  multicolor,
}: HeaderStyleProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <>
      <header
        className={cx(header.header, {
          [header.inverse]: inverse && !isMenuOpen,
          [header.overlay]: overlay,
          [header.multicolor]: multicolor,
        })}
      >
        <Navigation />
        <Logo className={header.logo} />
        <AccessMenu />
        <CartButton />
        <MenuButton isOpen={isMenuOpen} toggleOpen={toggleMenu} />
      </header>
      <SidebarMenu isOpen={isMenuOpen} />
    </>
  );
};
